module.exports = __webpack_public_path__ + "static/img/LB.8edf7926.svg";